<template>
  <div class="modal" id="platform_modal">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content cp-modal-content">
        <div class="modal-body text-center p-4">
          
          <div class="d-flex justify-content-end mb-2">
            <img @click="hide()" class="cp-modal-close" src="@/assets/images/stella/close.png" alt="Close">
          </div>

          <div class="cp-modal-avatar-wrapper">
            <div class="cp-modal-avatar-ring">
              <img v-if="imageURL" :src="imageURL" class="cp-modal-avatar">
              <img v-else class="cp-modal-avatar" src="@/assets/images/default_user.png">
            </div>
          </div>

          <h3 class="cp-modal-title">
            Subscribe to <span class="cp-modal-title-gradient">{{ inviteeName ? `@${inviteeName}` : '' }}</span>
          </h3>
          <p class="cp-modal-sub">{{ title }}</p>

          <div class="cp-modal-links mt-4">
            <button v-for="(influencerPlatform, index) in platforms"
                    :key="index" @click="goToPlatform(influencerPlatform)"
                    class="cp-modal-btn"
                    :class="{'cp-modal-btn--primary': index === 0}">
              <span class="cp-modal-btn__label">{{ getButtonLabel(influencerPlatform) }}</span>
              <span class="cp-modal-btn__arrow">→</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PLATFORM_INSTAGRAM,
  PLATFORM_SNAPCHAT,
  PLATFORM_STELLA
} from "@/properties/close-friend";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ModelPlatform",
  props: ['imageURL', 'inviteeName', 'platforms','urlPrefix'],
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getPlatform'])
  },
  methods: {
    ...mapActions(['setPlatform']),
    show(title) {
      if (title) {
        this.title = title;
      } else {
        this.title = 'Before submitting a custom request';
      }
      $('#platform_modal').modal();
    },
    hide() {
      $('#platform_modal').modal('hide');
    },
    goToPlatform(influencerPlatform) {
      this.hide();
      let customer = this.getUser;
      //This means it is logged in user
      if (customer) {
        let custPlatform = (customer.customerPlatforms && influencerPlatform && influencerPlatform.platform)
          ? customer.customerPlatforms.find(customerPlatform => customerPlatform.platform.name === influencerPlatform.platform.name)
          : null;
        //Check if the customer has registered with this platform
        if (custPlatform) {
          this.setPlatform(influencerPlatform);
          this.$emit('platformSelected');
        } else {
          this.$emit('platformNotRegistered', influencerPlatform);
        }
      } else {
        this.$emit('platformNotRegistered', influencerPlatform);
      }
    },
    getButtonLabel(influencerPlatform) {
      if (this.isInstagramPlatform(influencerPlatform)) {
        return 'Instagram Close Friends';
      } else if (this.isSnapchatPlatform(influencerPlatform)) {
        return 'Private Snapchat';
      } else if(influencerPlatform.isMessage) {
        return 'Send a message';
      } else if(this.isStellaPlatform(influencerPlatform)) {
          return 'All-Access';
      }
      return `Exclusive ${influencerPlatform.platform.name}`;
    },
    isInstagramPlatform(influencerPlatform) {
      if (influencerPlatform.platform.name.includes(PLATFORM_INSTAGRAM)) {
        return true;
      }
      return false;
    },
    isSnapchatPlatform(influencerPlatform) {
      if (influencerPlatform.platform.name.includes(PLATFORM_SNAPCHAT)) {
        return true;
      }
      return false;
    },
    isStellaPlatform(influencerPlatform) {
      if (influencerPlatform.platform.name.includes(PLATFORM_STELLA)) {
        return true;
      }
      return false;
    },

  }
}
</script>

<style scoped>
/* Modal Container */
.cp-modal-content {
  background: rgba(20, 20, 22, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.5);
}

.cp-modal-close {
  width: 14px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.cp-modal-close:hover {
  opacity: 1;
}

/* Avatar */
.cp-modal-avatar-wrapper {
  display: flex;
  justify-content: center;
  margin-top: -10px;
  margin-bottom: 20px;
}
.cp-modal-avatar-ring {
  padding: 4px;
  background: linear-gradient(135deg, #F3DA6B, #E53BB9, #70D5C2);
  border-radius: 50%;
  display: inline-block;
}
.cp-modal-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #141416;
}

/* Typography */
.cp-modal-title {
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 4px;
}
.cp-modal-title-gradient {
  background: linear-gradient(90deg, #F3DA6B, #E53BB9);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.cp-modal-sub {
  color: #9d9d9d;
  font-size: 14px;
  margin-bottom: 0;
}

/* Links */
.cp-modal-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cp-modal-btn {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
  background: rgba(255,255,255,0.03);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

/* Give each subsequent link a different accent color */
.cp-modal-btn:nth-child(1n) { border-left: 4px solid #E53BB9; }
.cp-modal-btn:nth-child(2n) { border-left: 4px solid #F3DA6B; }
.cp-modal-btn:nth-child(3n) { border-left: 4px solid #70D5C2; }
.cp-modal-btn:nth-child(4n) { border-left: 4px solid #FFDB7E; }
.cp-modal-btn:nth-child(5n) { border-left: 4px solid #AFE1D8; }

.cp-modal-btn:not(.cp-modal-btn--primary):hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateX(6px);
  border-color: rgba(229,59,185,0.4);
}

.cp-modal-btn--primary {
  background: linear-gradient(90deg, #F3DA6B, #E53BB9, #70D5C2, #F3DA6B) !important;
  background-size: 300% 100% !important;
  animation: gradient-shift 6s linear infinite !important;
  color: #222023 !important;
  border: none !important;
  font-weight: 700 !important;
}
.cp-modal-btn--primary .cp-modal-btn__arrow {
  color: #222023 !important;
}
.cp-modal-btn--primary:hover {
  background: linear-gradient(90deg, #F3DA6B, #E53BB9, #70D5C2, #F3DA6B) !important;
  background-size: 300% 100% !important;
  animation: gradient-shift 6s linear infinite !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(229,59,185,0.4) !important;
}

.cp-modal-btn:nth-child(1n) .cp-modal-btn__arrow { color: #E53BB9; }
.cp-modal-btn:nth-child(2n) .cp-modal-btn__arrow { color: #F3DA6B; }
.cp-modal-btn:nth-child(3n) .cp-modal-btn__arrow { color: #70D5C2; }
.cp-modal-btn:nth-child(4n) .cp-modal-btn__arrow { color: #FFDB7E; }
.cp-modal-btn:nth-child(5n) .cp-modal-btn__arrow { color: #AFE1D8; }

@keyframes gradient-shift {
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
}
</style>
